import { useState } from "react";
import { animeList, animeCategories } from "@/mocks/anime";

export default function AnimeSection() {
  const [category, setCategory] = useState<string>("all");
  const [keyword, setKeyword] = useState("");

  const filtered = animeList.filter((item) => {
    const matchCat = category === "all" || item.category === category;
    const matchKw =
      keyword.trim() === "" ||
      item.title.includes(keyword.trim()) ||
      item.tags.some((tag) => tag.includes(keyword.trim()));
    return matchCat && matchKw;
  });

  return (
    <section id="anime" className="w-full bg-background-50 py-20 md:py-24">
      <div className="container-site">
        <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
          <span className="inline-block rounded-full bg-accent-100 px-4 py-1.5 text-sm font-semibold text-accent-700">
            热门番剧
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            新番老番,多源稳定畅看
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            热门新番、经典老番、国漫精选与剧场版,每部都支持多线路播放,快速找到可播线路。
          </p>
        </div>

        <div className="mt-10 flex flex-col items-stretch justify-between gap-4 lg:flex-row lg:items-center">
          <div className="flex flex-wrap gap-2" role="tablist" aria-label="番剧分类">
            {animeCategories.map((cat) => (
              <button
                key={cat.key}
                type="button"
                role="tab"
                aria-selected={category === cat.key}
                onClick={() => setCategory(cat.key)}
                className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                  category === cat.key
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          <div className="flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2 lg:w-72">
            <i className="ri-search-line text-base text-foreground-500" aria-hidden="true"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索番剧名称或标签"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              aria-label="搜索番剧"
            />
            {keyword && (
              <button
                type="button"
                onClick={() => setKeyword("")}
                className="text-foreground-400 transition-colors hover:text-foreground-600"
                aria-label="清空搜索"
              >
                <i className="ri-close-circle-fill text-lg" aria-hidden="true"></i>
              </button>
            )}
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="mt-14 flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-100 py-16 text-center">
            <i className="ri-inbox-line text-4xl text-foreground-400" aria-hidden="true"></i>
            <p className="text-base text-foreground-700">没有找到匹配的番剧,换个关键词试试吧。</p>
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4">
            {filtered.map((item) => (
              <article key={item.id} className="group overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <div className="relative aspect-[3/4] w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} 动漫海报`}
                    title={`${item.title} 多线路高清播放`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-3 py-1 text-xs font-semibold text-background-50 backdrop-blur-sm">
                    ★ {item.rating}
                  </span>
                  <span className="absolute bottom-3 right-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                    {item.lines.length} 线路
                  </span>
                  <button
                    type="button"
                    className="absolute inset-0 flex items-center justify-center bg-foreground-950/0 opacity-0 transition-all duration-300 group-hover:bg-foreground-950/40 group-hover:opacity-100"
                    aria-label={`播放 ${item.title}`}
                  >
                    <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 text-2xl text-background-50 shadow-lg">
                      <i className="ri-play-fill" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
                <div className="flex flex-col gap-2 p-4">
                  <h3 className="truncate text-base font-bold text-foreground-950">{item.title}</h3>
                  <div className="flex flex-wrap gap-1.5">
                    {item.tags.map((tag) => (
                      <span key={tag} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>{item.episode}</span>
                    <span>{item.year}</span>
                  </div>
                  <div className="flex flex-wrap gap-1.5 border-t border-background-200 pt-3">
                    {item.lines.slice(0, 2).map((line) => (
                      <span key={line} className="rounded-md bg-primary-50 px-2 py-1 text-[11px] font-medium text-primary-700">
                        {line}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}